import { render, staticRenderFns } from "./MonitorView.vue?vue&type=template&id=b442ecaa&scoped=true"
import script from "./MonitorView.vue?vue&type=script&lang=js"
export * from "./MonitorView.vue?vue&type=script&lang=js"
import style0 from "./MonitorView.vue?vue&type=style&index=0&id=b442ecaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b442ecaa",
  null
  
)

export default component.exports